import type { Dictionnaire } from '../type';
import { compte } from './pluriel';

export const fil: Dictionnaire['fil'] = {
  erreurs: {
    supprimerLesSiens: 'يمكنك حذف منشوراتك فقط',
    pasTaReponse: 'هذا الردّ ليس لك',
    commentaireVide: 'تعليق فارغ',
    vide: 'اكتب شيئًا قبل النشر',
    tropLong: (max: number) => `${max} حرفًا كحد أقصى`,
  },
  commun: {
    retirerLike: 'إلغاء الإعجاب',
    liker: 'إعجاب',
    likerReponse: 'الإعجاب بهذا الردّ',
    retirerSignet: 'إزالة من المحفوظات',
    enregistrer: 'حفظ في محفوظاتي',
    actionsPost: 'إجراءات المنشور',
    actionsReponse: 'إجراءات الردّ',
    voirPhoto: 'عرض الصورة بملء الشاشة',
    photoDe: (auteur: string) => `صورة نشرها ${auteur}`,
    supprimerPostQ: 'حذف هذا المنشور؟',
    supprimerPost: 'حذف هذا المنشور',
    supprimerReponseQ: 'حذف هذا الردّ؟',
    supprimerReponse: 'حذف هذا الردّ',
    signaler: 'الإبلاغ عن المحتوى',
    partager: 'مشاركة',
    suppressionImpossible: 'تعذّر الحذف.',
    reponses: 'الردود',
    commenter: 'تعليق',
  },
  signets: {
    onglets: {
      posts: 'المنشورات',
      evenements: 'الفعاليات',
    },
    titre: 'محفوظاتي',
    aucunPost: 'لا توجد منشورات محفوظة',
    aucunPostAide: 'احفظ منشورًا أو ردًّا لتجده هنا.',
    aucuneSortie: 'لا توجد فعاليات محفوظة',
    aucuneSortieAide: 'اضغط على علامة الحفظ في صفحة الفعالية لتبقيها في متناولك.',
    compte: (n: number) => `${n} محفوظ`,
  },
  cloche: {
    verbes: {
      like: 'أعجبه منشورك',
      commentaire: 'ردّ على منشورك',
      mention: 'أشار إليك في منشور',
      signet: 'حفظ منشورك',
    },
    titre: 'الإشعارات',
    activite: 'النشاط',
    vide: 'لا يوجد نشاط بعد',
    nouvelles: (n: number) => `الإشعارات · ${n} جديدة`,
  },
  composeur: {
    annulerReponse: 'إلغاء الردّ على هذا الردّ',
    ecrire: 'اكتب تعليقًا…',
    envoyer: 'إرسال',
    reponseA: 'ردًّا على',
    repondreA: (nom: string) => `الردّ على ${nom}…`,
  },
  reponse: {
    voirReponses: (n: number) => `عرض ${compte(n, 'ردّ واحد', 'ردّين', 'ردود', 'ردًّا')}`,
    repondreA: (nom: string) => `الردّ على ${nom}`,
  },
  fil: {
    envoiImpossible: 'تعذّر إرسال الردّ',
    partagerReponse: 'مشاركة هذا الردّ',
    vide: 'لا توجد ردود',
    videAide: 'كن أول من يردّ على هذا التعليق.',
  },
  commentaires: {
    envoiImpossible: 'تعذّر إرسال التعليق',
    titre: 'التعليقات',
    vide: 'لا توجد تعليقات',
    videAide: 'كن أول من يتفاعل مع هذا المنشور.',
  },
  composer: {
    impossible: 'تعذّر النشر',
    titre: 'منشور جديد',
    publier: 'نشر',
    lieu: 'المكان',
    evenement: 'الفعالية',
    photoJointe: 'الصورة المرفقة بالمنشور',
    retirerPhoto: 'إزالة الصورة',
    visible: 'مرئي للخادم كله',
    remplacerPhoto: 'استبدال الصورة',
    ajouterPhoto: 'إضافة صورة',
    ajouterLieu: 'إضافة مكان',
    joindreEvenement: 'إرفاق فعالية',
    ajouterCeLieu: 'إضافة هذا المكان',
    retirerLieu: 'إزالة المكان',
    termine: 'تم',
    retirer: 'إزالة',
    quelEvenement: 'أي فعالية؟',
    aucunEvenement: 'لا توجد فعاليات قادمة',
    aucunEvenementAide: 'أنشئ واحدة من تبويب الفعاليات.',
    quoiDeNeuf: (lieu: string) => `ما الجديد في ${lieu}؟`,
    lieuChoisi: (lieu: string) => `المكان: ${lieu}`,
    evenementChoisi: (titre: string) => `الفعالية: ${titre}`,
    ouDans: (lieu: string) => `أين في ${lieu}؟`,
  },
  ecran: {
    vues: {
      pourToi: 'لك',
      recent: 'الأحدث',
    },
    supprime: 'حُذف المنشور.',
    rechercher: 'ابحث في المنشورات…',
    rechercherLabel: 'البحث في الأخبار',
    ecrire: 'اكتب منشورًا',
    masquerQ: 'إخفاء هذا المنشور؟',
    masquer: 'إخفاء هذا المنشور',
    aucunResultat: 'لا توجد نتائج',
    vide: 'الأخبار فارغة بعد',
    videAide: 'كن أول من يبدأ حديثًا في هذا الخادم.',
    premierPost: 'اكتب أول منشور',
    rienNeCorrespond: (recherche: string) => `لا شيء يطابق «${recherche}» في هذا الخادم.`,
  },
  mesPosts: {
    titre: 'منشوراتي',
    voirQuiAAime: 'من أعجبه المنشور',
    jaime: 'الإعجابات',
    personne: 'لم يُعجب أحد بهذا المنشور بعد.',
    vide: 'لا توجد منشورات',
    videAide: 'ستظهر منشوراتك هنا.',
    compte: (n: number) => compte(n, 'منشور واحد', 'منشوران', 'منشورات', 'منشورًا'),
  },
};
